import { IconName } from '@shinetools/sunshine-icons';
import { Pathname, Search } from 'history';

import {
  InsurancesCoverage as InsurancesCoverageSchema,
  InsurancesCoverage2024,
  ProviderPlanId,
} from '__generated__/GQL';
import {
  InsurancesOffer,
  OfferWithCoverage,
} from 'features/Insurance/hooks/useNewInsuranceCoverage/types';

type AllInsurancesCoverage = Omit<InsurancesCoverageSchema, '__typename'> &
  Omit<InsurancesCoverage2024, '__typename'>;

export type OfferId = keyof AllInsurancesCoverage | 'fromPartners';

export interface Offer {
  title: string;
  description: string;
  icon: IconName;
}

export type OfferDetailsFromSource =
  | 'all-offers'
  | 'similar-offers'
  | 'upgrade-encouragement';

export type OfferLinkProps = {
  pathname: Pathname;
  search?: Search;
  state?: {
    from: OfferDetailsFromSource;
  };
};

export type OfferWithLink = Offer & {
  path: OfferLinkProps;
};

export type Group = 'travel' | 'legal' | 'payment' | 'materialAndBody';

export type GroupItem = {
  title: string;
  icon: string;
  description: string;
};

export type GroupItemWithOfferKeys = GroupItem & {
  offers: Array<InsurancesOffer>;
};

export type GroupItemWithOffersCoverage = GroupItem & {
  offers: Array<OfferWithCoverage>;
};

export enum AssuredBy {
  MutuaideAssistance = 'Mutuaide Assistance',
  Shine = 'Shine',
}

export type SelectedProviderPlanId =
  | ProviderPlanId.Business
  | ProviderPlanId.Pro
  | ProviderPlanId.Plus
  | ProviderPlanId.Basic;

export const isSelectedProviderPlanId = (
  planId: ProviderPlanId,
): planId is SelectedProviderPlanId => {
  return (
    planId === ProviderPlanId.Basic ||
    planId === ProviderPlanId.Business ||
    planId === ProviderPlanId.Pro ||
    planId === ProviderPlanId.Plus
  );
};
